import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {
  IconSettings,
  Button,
  Card,
  Modal,
} from '@salesforce/design-system-react';

import CustomToastContainer from '../../Components/App/CustomToastContainer';
import MilestoneBar from '../../Components/Milestones/MilestoneBar';
import PotentialMilestones from '../../Components/Milestones/PotentialMilestones';
import MilestoneInstructions from '../../Components/Sidebars/Instructions/MilestoneInstructions';
import PageBlockHeader from '../../Components/PageBlockHeader';
import VidyardEmbed from '@vidyard/embed-code';
import { socket } from '../../socket';
import Sidebar from '../../Components/Sidebars/App/Sidebar';
import Banner from '../../Components/App/Banner';
import AddIdea from '../../Components/AddIdea';

import {
  setStepId,
  addToast,
  addMilestoneDBOnly,
  addMilestone,
  addIdeaDBOnly,
  addIdea,
  selectIdeaDBOnly,
  selectIdea,
  updateIdeaDBOnly,
  updateIdea,
  deleteIdeaDBOnly,
  deleteIdea,
} from '../../actions';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  const toggle = React.useCallback(() => {
    setValue(v => !v);
  }, []);

  return [value, toggle];
}

let milestones = {
  1: 'trigger',
  2: 'triumph',
  3: 'guide',
  4: 'key',
  5: 'crisis',
};

function Milestone (props) {
  const [milestone, setMilestone] = useState('trigger');
  const [milestoneStep, setMilestoneStep] = useState(1);
  const [idea, setIdea] = useState('');
  const [capMilestone, setCapMilestone] = useState('');
  const [isIdeaOpen, setIsIdeaOpen] = useToggle();
  const [editing, setEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [chosen, setChosen] = useState(false);

  useEffect(() => { 
    VidyardEmbed.api.renderDOMPlayers();

    setCapMilestone(milestone.charAt(0).toUpperCase() + milestone.slice(1));
    socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);

  const submitIdea = async() => {
    if (idea !== '' && editing && idea.length < 256) {
      if (chosen) {
        await props.addMilestoneDBOnly(props.journeyId, milestone, props.milestones[milestone].id, idea);
        setChosen(false);
      }

      await props.updateIdeaDBOnly(null, editingId, milestone, idea);

      closeAddIdea();
    } else if(idea !== '' && idea.length < 256) {
      await props.addIdeaDBOnly(props.journeyId, null, milestone, idea);

      closeAddIdea();
    } else if (idea.length >= 256) {
      props.addToast({ labels: { heading: 'Idea needs to be 255 or less characters.' }, variant: 'error' });
    } 
    else {
      props.addToast({ labels: { heading: 'Please make sure your idea has content.' }, variant: 'error' });
    }
  };

  const openEditIdea = async(ideaId, content, miletone, chosen) => {
    setEditing(true);
    setEditingId(ideaId);
    setIdea(content);
    setChosen(chosen);
    setIsIdeaOpen();
  }

  const closeAddIdea = () => {
    setIsIdeaOpen();
    setEditing(false);
    setEditingId(null);
    setIdea('');
    setChosen(false);
  }

  const handleIdeaActions = async (ideaId, action, content, chosen) => {
    if (action === 'Delete') {
      await props.deleteIdeaDBOnly(null, milestone, ideaId);

      if (chosen) {
        await props.addMilestoneDBOnly(props.journeyId, milestone, props.milestones[milestone].id, "");
      }
    } else if (action === 'Select') {
      await props.selectIdeaDBOnly(props.journeyId, null, milestone, ideaId);

      await props.addMilestoneDBOnly(props.journeyId, milestone, props.milestones[milestone].id, content);
    }
  };

  const goToPreviousMilestone = () => {
    if (milestone !== 'trigger') {
      setCapMilestone(milestones[milestoneStep - 1].charAt(0).toUpperCase() + milestones[milestoneStep - 1].slice(1));
      setMilestone(milestones[milestoneStep - 1]);
      setMilestoneStep(milestoneStep - 1);
    } else {
      props.history.push("/Milestones");

      window.location.href = '/Personas';
    }
  };

  const goToNextMilestone = async () => {
    let ideas = Object.values(props.ideas[milestone]);

    if (ideas.filter((idea) => idea.chosen).length === 0) {
      props.addToast({
        labels: {
          heading: `Please fill out and select an idea as a ${milestone}.`,
        },
        variant: 'error',
      });
    } else {
      if (milestone === 'crisis') {
        nextScreen();
      } else {
        setCapMilestone(milestones[milestoneStep + 1].charAt(0).toUpperCase() + milestones[milestoneStep + 1].slice(1));
        setMilestone(milestones[milestoneStep + 1]);
        setMilestoneStep(milestoneStep + 1);
      }
    }
  };

  const nextScreen = () => {
    props.setStepId(4);

    props.history.push("/Milestones");
    
    window.location.href = '/MilestoneConnectors';
  };

  const goToMilestone = (event) => {

    let milestones = {
      1: 'trigger',
      2: 'triumph',
      3: 'guide',
      4: 'keyVar',
      5: 'crisis',
    };

    let mapTheMiddle = ['guide', 'keyVar', 'crisis'];
    let nextMilestone = event.target.getAttribute('data-milestone');
    let nextMilestoneStep = parseInt(
      Object.keys(milestones).find((key) => milestones[key] === nextMilestone),
      10
    );
    let filled = event.target.getAttribute('data-fill');
    let clickable = event.target.getAttribute('data-clickable');

    if (clickable === 'true') {
      if (milestones[nextMilestoneStep] === 'keyVar') {
        setCapMilestone('Key');
        setMilestone('key');
        setMilestoneStep(nextMilestoneStep);
      } else {
        setCapMilestone(milestones[nextMilestoneStep].charAt(0).toUpperCase() + milestones[nextMilestoneStep].slice(1));
        setMilestone(milestones[nextMilestoneStep]);
        setMilestoneStep(nextMilestoneStep);
      }
    } else if (!filled && this != undefined && this.nextMilestoneStep > milestoneStep) {
      props.addToast({
        labels: {
          heading: `Please fill out and select an idea as a ${milestone}.`,
        },
        variant: 'error',
      });
    }
  };

  return (
    <IconSettings iconPath="/icons">
      <CustomToastContainer />
      <div className="outer-container">
        <Sidebar 
          stage="Milestones"
          instructions={<MilestoneInstructions displayMilestone={capMilestone} milestone={milestone} />}
        />
        <Banner
          goToMilestone={goToMilestone}
          milestone={milestone}
          backgroundColor='#E1DFF0'
          previous={goToPreviousMilestone}
          next={goToNextMilestone}
          stage="Milestones"
          backgroundImage='/Images/Banners/HeroBanners-03.png'
        />
        <div>
          {/*<SocketListeners />*/}
          <div style={{ marginLeft: 'max(210px, 15%)'}}>
            <div className="slds-p-horizontal_x-large slds-p-vertical_medium">
            <MilestoneBar
              onMilestoneClicked={goToMilestone}
              milestone={milestone}
              triggerContent={props.milestones.trigger.content}
              guideContent={props.milestones.guide.content}
              keyContent={props.milestones.key.content}
              crisisContent={props.milestones.crisis.content}
              triumphContent={props.milestones.triumph.content}
            /> 
            <Card 
              heading={
              (<div> 
             
                <div className="slds-grid">
                  <div className="slds-size_11-of-12">
                  {capMilestone === 'KeyVar' ? (
                    <PageBlockHeader
                      hasBorder={false}
                      title={`Milestone: `}
                      addtl={`Key`}
                      subtitle={`Step 1: Add Possible Milestone Events. Step 2: Select Your Favorite`}
                    />
                  ) : (
                    <PageBlockHeader
                      hasBorder={false}
                      title={`Milestone: `}
                      addtl={`${capMilestone}`}
                      subtitle={`Step 1: Add Possible Milestone Events. Step 2: Select Your Favorite`}
                    />
                  )}
                  </div>
                  <div className="slds-size_1-of-12">
                    <Button 
                      label="Next Stage" 
                      variant="brand"
                      onClick={goToNextMilestone} 
                      style={{ fontSize: '13px'}}
                    />
                  </div>
                </div>
              </div>
              )}
              className="slds-p-horizontal_x-small slds-m-top_x-small"
              style={{ minHeight: '550px'}}
            >
              <div className="slds-m-top_large">
                <PotentialMilestones
                  ideas={props.ideas[milestone]}
                  milestone={
                    milestone === 'keyVar'
                      ? 'key'
                      : milestone
                  }
                  onDropdownSelected={handleIdeaActions}
                  onButtonClick={setIsIdeaOpen}
                  imgPath="/icons/utility/add.svg"
                  color="#f5604d"
                  imgSize="40"
                  border="10px solid white"
                  openEditIdea={openEditIdea}
                />
              </div>
            </Card>
          </div>
        </div>
        </div>
        <Modal
          isOpen={isIdeaOpen}
          onRequestClose={closeAddIdea}
        >
          <AddIdea
            milestone={milestone}
            value={idea}
            onChange={(e) => setIdea(e.target.value)}
            onAdd={submitIdea}
            onCancelButtonClick={closeAddIdea}
          />
        </Modal>
      </div>
    </IconSettings>
  );
}

// variables
const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
  businessChallenge: state.businessChallenge,
  milestones: state.milestones,
  ideas: state.ideas,
});

// functions
const mapDispatchToProps = (dispatch) => ({
  addToast: (toast) => dispatch(addToast(toast)),
  setStepId: (stepId) => dispatch(setStepId(stepId)),

  // -- ADD MILESTONE START --
  addMilestoneDBOnly: (journeyId, position, id, content) =>
    dispatch(addMilestoneDBOnly(journeyId, position, id, content)),
  addMilestone: (position, id, content) =>
    dispatch(addMilestone(position, id, content)),
  // -- ADD MILESTONE END --

  // -- ADD IDEA START --
  addIdeaDBOnly: (journeyId, personaId, stageName, ideaContent) =>
    dispatch(addIdeaDBOnly(journeyId, personaId, stageName, ideaContent)),
  addIdea : (ideaId, personaId, stageName, ideaContent, chosen) =>
    dispatch(addIdea(ideaId, personaId, stageName, ideaContent, chosen)),
  // -- ADD IDEA END -- 

  // -- SELECT IDEA START --
  selectIdeaDBOnly: (journeyId, personaId, stageName, ideaId) =>
    dispatch(selectIdeaDBOnly(journeyId, personaId, stageName, ideaId)),
  selectIdea: (personaId, stageName, ideaId, chosen) =>
    dispatch(selectIdea(personaId, stageName, ideaId, chosen)),
  // -- SELECT IDEA END --

  // -- UPDATE IDEA START -- CERTIFIED
  updateIdeaDBOnly: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdeaDBOnly(personaId, ideaId, stageName, ideaContent)),
  updateIdea: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdea(personaId, ideaId, stageName, ideaContent)),
  // -- UPDATE IDEA END --

  // -- DELETE IDEA START --
  deleteIdeaDBOnly: (personaId, stageName, id) =>
    dispatch(deleteIdeaDBOnly(personaId, stageName, id)),
  deleteIdea: (stageName, ideaId) =>
    dispatch(deleteIdea(stageName, ideaId)),
  // -- DELETE IDEA END --
});

export default connect(mapStateToProps, mapDispatchToProps)(Milestone);
